<script lang="ts">
  import type { Emodel } from "../../helpers/types";

  interface Props {
    eModels: Emodel[];
  }

  let { eModels }: Props = $props();
</script>

<div class="bg-Neutral100 rounded-md p-2 flex flex-col space-y-2 mb-2 shadow-3xl">
  {#if eModels.length === 0}
    <div class="bg-Neutral110 rounded-md pl-2 py-1">
      <span class="text-Neutral900 text-base">Kunde inte hitta några enheter</span>
    </div>
  {:else}
    {#each eModels as eModel}
      <div class="bg-Neutral110 rounded-md pl-2 py-1">
        <span class="text-Neutral900 text-base">{eModel.fullname}</span>
      </div>
    {/each}
  {/if}
  <a
    href="https://skekraft.se/smartstyrning/enheter"
    class="text-Violet900 text-base hover:underline p-2"
    target="_blank">Se alla kompatibla produkter (öppnas i ny flik)</a
  >
</div>
